import React, { useMemo } from 'react';
import classNames from 'classnames';
import { CouponBanner } from '@bingads-webui-campaign-react/coupon-banner';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { usePromotionBannerState } from './use-promotion-banner-state';
import { getPromotionBannerStyles } from './styles/promotion-banner-style';

// Banner to display Coupon promotional offers
export const PromotionBanner = () => {
  const [{ bannerInfo, shouldShowBanner }] = usePromotionBannerState();
  const classes = useDefaultStyles(getPromotionBannerStyles);

  const renderBanner = useMemo(() => (
    shouldShowBanner ?
      <div className={classNames('promotion-banner', classes.promotionBanner)}>
        <CouponBanner
          showCouponAlert
          couponInfo={bannerInfo}
        />
      </div>
      : null
  ), [classes.promotionBanner, bannerInfo, shouldShowBanner]);

  return renderBanner;
};
